var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChargePointIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    fill: "url(#paint0_linear_677_10754)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.40201,
    y: 2.40201,
    width: 36.7538,
    height: 36.7538,
    rx: 11.1859,
    stroke: "#F9F9F9",
    strokeWidth: 3.19598
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9038 27.4456C18.9038 28.4811 19.7433 29.3206 20.7788 29.3206C21.8143 29.3206 22.6538 28.4811 22.6538 27.4456C22.6538 26.41 21.8143 25.5706 20.7788 25.5706C19.7433 25.5706 18.9038 26.41 18.9038 27.4456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5703 27.4456C25.5703 28.4811 26.4098 29.3206 27.4453 29.3206C28.4808 29.3206 29.3203 28.4811 29.3203 27.4456C29.3203 26.41 28.4808 25.5706 27.4453 25.5706C26.4098 25.5706 25.5703 26.41 25.5703 27.4456Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2373 27.4456C12.2373 28.4811 13.0768 29.3206 14.1123 29.3206C15.1478 29.3206 15.9873 28.4811 15.9873 27.4456C15.9873 26.41 15.1478 25.5706 14.1123 25.5706C13.0768 25.5706 12.2373 26.41 12.2373 27.4456Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9038 14.1121C18.9038 15.1476 19.7433 15.9871 20.7788 15.9871C21.8143 15.9871 22.6538 15.1476 22.6538 14.1121C22.6538 13.0765 21.8143 12.2371 20.7788 12.2371C19.7433 12.2371 18.9038 13.0765 18.9038 14.1121Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1536 26.6122C20.1536 26.9539 20.437 27.2372 20.7786 27.2372C21.1203 27.2372 21.4036 26.9539 21.4036 26.6122L21.4036 20.5706L24.9453 20.5706C26.262 20.5706 26.8203 21.1289 26.8203 22.4456L26.8203 26.6122C26.8203 26.9539 27.1036 27.2372 27.4453 27.2372C27.787 27.2372 28.0703 26.9539 28.0703 26.6122L28.0703 22.4456C28.0703 20.4289 26.962 19.3206 24.9453 19.3206L21.4036 19.3206L21.4036 14.9456C21.4036 14.6039 21.1203 14.3206 20.7786 14.3206C20.437 14.3206 20.1536 14.6039 20.1536 14.9456L20.1536 19.3206L16.612 19.3206C14.5953 19.3206 13.487 20.4289 13.487 22.4456L13.487 26.6122C13.487 26.9539 13.7703 27.2372 14.112 27.2372C14.4536 27.2372 14.737 26.9539 14.737 26.6122L14.737 22.4456C14.737 21.1289 15.2953 20.5706 16.612 20.5706L20.1536 20.5706L20.1536 26.6122Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_677_10754",
    x1: 20.7789,
    y1: 4,
    x2: 20.7789,
    y2: 37.5578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChargePointIcon);
export default __webpack_public_path__ + "static/media/EmptyChargePointIcon.33cb89ede224140c0b6ea318483e2c05.svg";
export { ForwardRef as ReactComponent };